export const APP_DISPLAY_NAME = 'AWS Mission Networking Portal';
